module.exports = __webpack_public_path__ + "static/img/02.a4c541b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/news/02.png
// module id = G0ba
// module chunks = 1